module.exports = __webpack_public_path__ + "img/20210629_084550.47ae1a00.jpg";